export default "__VITE_ASSET__87172363__"